/**
 * MetricCard Component
 *
 * Display key metrics in a card format.
 */

import React from 'react';

export interface MetricCardProps {
  label: string;
  value: string | number;
  unit?: string;
  trend?: 'up' | 'down' | 'neutral';
  className?: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  label,
  value,
  unit,
  trend,
  className = '',
}) => {
  return (
    <div className={`bg-white border border-gray-200 rounded-lg p-4 ${className}`}>
      <div className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">
        {label}
      </div>
      <div className="flex items-baseline gap-1">
        <div className="text-2xl font-bold text-gray-900">{value}</div>
        {unit && <div className="text-sm text-gray-500">{unit}</div>}
      </div>
      {trend && (
        <div
          className={`text-xs mt-1 ${
            trend === 'up'
              ? 'text-green-600'
              : trend === 'down'
              ? 'text-red-600'
              : 'text-gray-500'
          }`}
        >
          {trend === 'up' ? '↑' : trend === 'down' ? '↓' : '→'}
        </div>
      )}
    </div>
  );
};
